export enum ClientKey {
    MotCuaWebApp = 'MotCuaWebApp',
}

export enum SocketEndpoint {
    hubs = 'hubs/core',
}

export enum SignalNotificationType {
    /** */
    None,
    /**Thông báo mới được tạo */
    Create,
    /**Thông báo bị xóa */
    Delete,
    /**Thông báo bị ẩn */
    Hidden,
}

export enum SignalMethod {
    /**Trigger sau khi connect signalsignal */
    SendAfterConnect = 'SendAfterConnect',
    SendCounter = 'SendCounter',
    /**Trigger thông báo hệ thống */
    SendSysNotification = 'SendSysNotification',
    /**Trigger thông báo APPNotification */
    SendNotification = 'SendNotification',
    /**Trigger thông báo hồ sơ */
    SendDossierNotification = 'SendDossierNotification',
    SendUXUpdate = 'SendUXUpdate',
    SendMaintenance = 'SendMaintenance',
    GetEndpointInfos = 'GetEndpointInfos',
}

/** */
export enum UXUpdateStatus {
    None,
}

/**Tên các app  */
export enum OGAppName {
    /**Cán bộ */
    Officers = 'MotCua',
    /**Khách hàng/sinh viên/công dân */
    Customers = 'ONEGATE',
}

/** */
export enum UXUpdateType {
    /**Không có */
    None,
    /**Đọc giao việc */
    ReadAssignTask,
    /**Đọc chi tiết xử lý */
    ReadDetailProcesses,
}

/**Trạng thái của thông báo signal */
export enum SignalRNotificationStatuses {
    InActive,
    Active,
    Unknown = -1,
}

/** Các thiết bị sử dụng */
export enum DeviceProfileType {
    Window,
    Android,
    Ios,
    Mac,
}
